<script>
    import RadioButton from '../../RadioButton/v1/RadioButton.svelte';
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let options = [];
    export let selected = undefined;
    export let name = '';
    export let label = '';
    export let id = '';
    export let useSmallRadioButtons = false;
    export let vertical = false;

    let nameText;
    $: {
        if (!name || typeof name !== 'string') {
            console.warn('Name must be supplied');
        } else {
            nameText = name;
        }
    }

    let cssClass = '';
    $: {
        cssClass = vertical ? 'column' : '';
    }

    let labelText;
    $: {
        if (!label || typeof label !== 'string') {
            console.warn('Label must be supplied');
        } else {
            labelText = label;
        }
    }

    let idText;
    $: {
        if (!id || typeof id !== 'string') {
            console.warn('Id must be supplied');
        } else {
            idText = id;
        }
    }

    function onSelected(event, button) {
        dispatch('selected', {
            event: event.event,
            value: button.value,
        });
    }
</script>

<fieldset id="{idText}" class="prom-radio-group">
    <legend id="{idText}__label" class="prom-radio-group__label-text"
        >{labelText}</legend>
    <span
        role="radiogroup"
        aria-labelledby="{idText}__label"
        class="prom-radio-group__option-group {cssClass}">
        {#each options as button}
            <RadioButton
                id="{button.id}"
                label="{button.label}"
                description="{button.description}"
                bind:selected
                disabled="{button.disabled}"
                name="{nameText}"
                value="{button.value}"
                small="{useSmallRadioButtons}"
                on:selected="{(event) => onSelected(event, button)}" />
        {/each}
    </span>
</fieldset>
